<template>
  <div class="form-list">
    <el-form
      ref="form"
      :model="card"
      label-position="right"
      label-width="160px"
      class="form"
    >
      <div class="table-title table-title-top">申请信息</div>
      <el-form-item label="申请时间">{{ card.add_time | timeToYmdHi }}</el-form-item>

      <el-form-item label="申请者">
        <v-avatar-nickname
          :value="card.admin_avatar"
          :nickname="card.admin_nickname"
          :is-center="false"
        />
      </el-form-item>

      <el-form-item label="申请门店">{{ card.add_store_name }}</el-form-item>

      <div class="table-title">课卡信息</div>

      <div class="field-group-label">基础信息</div>

      <el-form-item label="所属学员">
        <v-avatar-nickname
          :value="card.selfie"
          :nickname="card.student_name"
          :is-center="false"
          :link-page-name="RouteConfig.studentDetail.name"
          :link-page-id="card.student_id"
        />
      </el-form-item>

      <el-form-item label="课卡名称">{{ card.card_name }}</el-form-item>

      <el-form-item label="课卡类型">{{ card.card_type_name }}</el-form-item>

      <el-form-item v-show="card.is_number_limit" label="有效次数">
        <span class="primary-color">{{ card.expire_number }}</span> 次
      </el-form-item>

      <el-form-item label="有效天数">{{ card.expire_days }} 天</el-form-item>

      <el-form-item label="办卡日期">{{ card.register_time | timeToYmd }}</el-form-item>

      <el-form-item label="失效日期">{{ card.expire_time | timeToYmdHi }}</el-form-item>

      <el-form-item label="实际付款">
        <span class="income-color">{{ card.actual_payment }}</span> 元
      </el-form-item>

      <div class="table-title">退卡信息</div>

      <!-- 课次券提示 -->
      <v-card-ticket-warning
        v-if="cardTickets.length"
        :tickets="cardTickets"
        message="该课卡已绑定以下课次券，审核通过退卡后这些课次券将自动失效。"
      />

      <el-form-item label="退款金额" prop="del_payment">
        <span class="pay-color">{{ card.del_payment }}</span> 元
      </el-form-item>

      <el-form-item label="退卡原因">
        <el-radio disabled v-model="card.is_input_error" :label="0">非录入错误</el-radio>
        <el-radio disabled v-model="card.is_input_error" :label="1">录入错误</el-radio>
        <div class="danger-color">{{ card.del_remark }}</div>
      </el-form-item>

      <el-form-item label="退卡原因截图">
        <v-img v-if="card.del_cover" :value="card.del_cover"/>
        <span v-else class="info-color">无</span>
      </el-form-item>

      <template v-if="!isLoading && !isLoadingError && card.apply_state !== applyStates.review.value">
        <div class="table-title">审核信息</div>

        <el-form-item label="审核状态">
          <span v-if="currentApplyState" :class="`${currentApplyState.tagType}-color`">
            {{ currentApplyState.name }}
          </span>
        </el-form-item>

        <template v-if="card.apply_state === applyStates.passed.value || card.apply_state === applyStates.rejected.value">
          <el-form-item v-if="canViewReviewInfo" label="审核者">
            <template v-if="card.reviewer && card.reviewer.id">
              <v-avatar-nickname :value="card.reviewer.avatar" :nickname="card.reviewer.nickname" :is-center="false"/>
            </template>
            <span v-else class="info-color">未记录</span>
          </el-form-item>

          <el-form-item v-if="canViewReviewInfo" :label="currentApplyState && currentApplyState.timeLabel || '审核时间'">
            <template v-if="card.update_time">{{ card.update_time | timeToYmdHi }}</template>
            <span v-else class="info-color">未记录</span>
          </el-form-item>
        </template>
      </template>

      <el-form-item>
        <template v-if="!isLoading && !isLoadingError && card.apply_state === applyStates.review.value">
          <template v-if="isAdministrator">
            <el-button type="success" @click="handleSubmit(false)" :disabled="isSaving" :loading="isPassing">通过</el-button>
            <el-button type="danger" @click="handleSubmit(true)" :disabled="isSaving" :loading="isRejecting">驳回</el-button>
          </template>
          <el-button v-else type="danger" @click="handleSubmit(false)" :disabled="isSaving" :loading="isRevoking">撤回</el-button>
        </template>

        <el-button @click="RouteConfig.cardDeleteApplyList.back">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import RouteConfig from '@/router/config';
import { show, update, destroy } from "@/api/card-del-apply";
import { store } from "@/api/card-del-record";
import { toYuan } from "@/filters";
import { mapGetters } from 'vuex';
import { applyStates, findApplyState } from "@/enums/applyStates";

export default {
  name: RouteConfig.cardDeleteApplyDetail.name,
  data: () => ({
    RouteConfig,
    isSaving: false,
    isPassing: false,
    isRejecting: false,
    isRevoking: false,
    isLoading: false,
    isLoadingError: false,
    applyStates,
    cardTickets: [],
    card: {
      add_time: 0,
      update_time: 0,
      reviewer: {},
      is_reviewing: 0,
      student_id: 0,
      selfie: '',
      student_name: '',
      add_store_name: '',
      card_name: '',
      card_type_name: '',
      expire_number: '',
      expire_days: '',
      register_time: '',
      expire_time: '',
      actual_payment: '',
      apply_state: applyStates.review.value,

      admin_nickname: '',
      admin_avatar: '',

      del_cover: '',
      del_payment: 0,
      del_remark: '',
      is_input_error: 0,
      store_id: 0,
    },
  }),
  computed: {
    ...mapGetters(['isAdministrator', 'userStoreId']),
    canViewReviewInfo() {
      return this.isAdministrator || this.userStoreId === this.card.store_id;
    },
    id() {
      return +this.$route.params.id || 0;
    },
    currentApplyState() {
      const result = findApplyState(this.card.apply_state);
      return result.length ? result[0] : undefined;
    },
  },
  beforeMount() {
    this.show();
  },
  methods: {
    async show() {
      this.isLoading = true;
      this.isLoadingError = false;
      const { isError, data } = await show(this.id);
      if (isError) {
        this.isLoading = false;
        this.isLoadingError = true;
        return;
      }

      this.cardTickets = data.card_tickets || [];

      if (data.expire_number) data.expire_number = toYuan(data.expire_number);
      if (data.actual_payment) data.actual_payment = toYuan(data.actual_payment);
      if (data.del_payment) data.del_payment = toYuan(data.del_payment);

      const { card } = this;
      const updateCardInfo = {};
      Object.keys(data).forEach(key => {
        if (key in card) updateCardInfo[key] = data[key];
      });
      Object.assign(card, updateCardInfo);
      this.isLoading = false;
    },
    handleSubmit(isReject = false) {
      if (this.isSaving) return;

      this.$refs.form.validate(async (isSuccess) => {
        if (!isSuccess) return;

        this.isSaving = true;
        let method = destroy;
        if (this.isAdministrator) {
          method = isReject ? update : store;
        }
        if (method === destroy) {
          this.isRevoking = true;
        } else if (method === update) {
          this.isRejecting = true;
        } else {
          this.isPassing = true;
        }
        const { isError } = await method(this.id);
        this.isSaving = false;
        this.isRevoking = false;
        this.isRejecting = false;
        this.isPassing = false;
        if (isError) return;

        let apply_state = this.isAdministrator ? applyStates.review.value : applyStates.revoked.value;
        RouteConfig.cardDeleteApplyList.push({ apply_state });
      });
    },
  },
};
</script>
<style src="./card-detail.css" scoped/>
